import React from 'react';
import { Link, withRouter } from 'react-router-dom/cjs/react-router-dom.min';
import Paginations from '../../common/paginations';
import constant from '../../../constant';

const ExpenseTypeList = ({ data, setCurrentPage, limit, onChangeVisibility }) => {
    const { expenseTypes, total, page } = data;

    return (
        <React.Fragment>
            <div className="table-responsive">
                <table className="table align-middle table-hover table-bordered">
                    <thead className="table-light">
                        <tr>
                            <th>#</th>
                            <th>Expense Type</th>
                            <th>Code</th>
                            <th>Description</th>
                            <th>Reimbursable</th>
                            <th>Bill Required</th>
                            <th>Status</th>
                            <th>Modified By</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {expenseTypes?.length > 0 ? (
                            expenseTypes.map((item, index) => (
                                <tr key={index}>
                                    <td>
                                        <div className="avatar-xs">
                                            <span className="avatar-title rounded-circle bg-light text-primary">
                                                {item.EXPENSE_TYPE_NAME?.charAt(0).toUpperCase()}
                                            </span>
                                        </div>
                                    </td>
                                    <td>{item.EXPENSE_TYPE_NAME}</td>
                                    <td>{item.EXPENSE_CODE}</td>
                                    <td>{item.DESCRIPTION || '-'}</td>
                                    <td>{item.IS_REIMBURSABLE ? 'Yes' : 'No'}</td>
                                    <td>{item.IS_BILL_REQUIRED ? 'Yes' : 'No'}</td>
                                    <td>
                                        <span
                                            className={`badge rounded-pill ${
                                                item.IS_ACTIVE ? 'bg-success' : 'bg-secondary'
                                            }`}
                                        >
                                            {item.IS_ACTIVE ? 'Active' : 'Inactive'}
                                        </span>
                                    </td>
                                    <td>{item.MODIFIED_BY_NAME || '-'}</td>
                                    <td>
                                        <ul className="list-inline font-size-20 contact-links mb-0">
                                            <li className="list-inline-item">
                                                <Link
                                                    to={{
                                                        pathname: constant.Authedcomponent.editExpenseTypeMasterData.url,
                                                        state: {
                                                            data: btoa(JSON.stringify(item)),
                                                            page: page,
                                                        },
                                                    }}
                                                    title="Edit"
                                                >
                                                    <i className="bx bx-edit text-primary"></i>
                                                </Link>
                                            </li>
                                            <li className="list-inline-item">
                                                <a
                                                    href="javascript:void(0);"
                                                    onClick={() => onChangeVisibility(item)}
                                                    title="Change Status"
                                                    className="text-danger"
                                                >
                                                    <i className={`bx ${item.IS_ACTIVE ? 'bx-trash' : 'bx-undo'}`} />
                                                </a>
                                            </li>
                                        </ul>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="9" className="text-center">
                                    No Expense Types found.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            <Paginations
                limit={limit}
                totalCount={total}
                range={5}
                currentPage={page}
                onPageChange={setCurrentPage}
            />
        </React.Fragment>
    );
};

export default withRouter(ExpenseTypeList);
